import { useNavigate, matchPath, useLocation } from 'react-router';

export const useNavigationHelper = () => {
  const navigateHook = useNavigate();
  const location = useLocation();

  const navigate = (url: string, isExternal: boolean) => {
    if (isExternal) {
      window.location.href = url;
    } else {
      navigateHook(url);
    }
  };

  const isActiveRoute = (url: string, exact: boolean): boolean => {
    return !!matchPath({ path: url, end: exact }, location.pathname ?? '');
  };

  return { navigate, isActiveRoute };
};
